module.exports = __webpack_public_path__ + "media/images/new_home/half-green-icon-348737cfe0843c5ccaaa25b1250cf9e6.png";